"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { type ReactNode, useState } from "react";
import { CookiesProvider } from "react-cookie";
import { PlanProvider } from "@/contexts/plan-context";
import { EnumsProvider } from "@/enums/context";
import NotificationsProvider from "./notifications-provider";

export default function Provider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
          },
        },
      })
  );
  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <PlanProvider>
          <NotificationsProvider>
            <EnumsProvider>
              {process.env.NODE_ENV === "development" && (
                <ReactQueryDevtools initialIsOpen={false} />
              )}
              {children}
            </EnumsProvider>
          </NotificationsProvider>
        </PlanProvider>
      </QueryClientProvider>
    </CookiesProvider>
  );
}
